export default function($) {

  display_product_variation_price()
  display_product_variation_image()
  toggle_minimal_price();

  $('.js-product-variation-select').on('change', function() {
    display_product_variation_price()
    display_product_variation_image()
    toggle_minimal_price();
  })

  function display_product_variation_price() {
    var model_selected = $('input[name=model]:checked', '#js-product-variation-select-form').val();
    $('.js-product-variation-price').each( function() {

      if( $(this).attr('id') === model_selected+'-cart' ) {
        $('.js-product-variation-price').addClass('hidden');
        $(this).toggleClass('hidden');
      }
    })
  }

  function display_product_variation_image() {
    var src = $('input[name=model]:checked', '#js-product-variation-select-form').data( 'image-src' ),
        srcXXLarge = $('input[name=model]:checked', '#js-product-variation-select-form').data( 'image-xxlarge' ),
        srcset = $('input[name=model]:checked', '#js-product-variation-select-form').data( 'image-srcset' ),
        alt = $('input[name=model]:checked', '#js-product-variation-select-form').data( 'image-alt' ),
        title = $('input[name=model]:checked', '#js-product-variation-select-form').data( 'image-title' );

    if ( src !== null ) {
      $('#main-image').attr( 'src', src );
      $('#main-image').attr( 'srcset', srcset );
      $('#main-image-full').attr( 'href', srcXXLarge );
      $('#main-image-full').data( 'title', title );
      $('#main-image-full').data( 'alt', alt );
    }
  }

  function toggle_minimal_price() {
    var model_selected = $('input[name=model]:checked', '#js-product-variation-select-form').val();

    if (model_selected) {
      $('#js-product-minimal-price').addClass('hidden');
    } else {
      $('#js-product-minimal-price').removeClass('hidden');
    }
  }

}
